import React from 'react';

export const optionFactory = (options) => {
	return options.map((opt) => {
		return <option
			value = { opt.value }
			key = { opt.value }
		>
			{opt.display}
		</option>
	});
}


// WEBPACK FOOTER //
// ./src/components/shared/optionFactory.jsx